import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Estoque, EstoqueActions, EstoqueState, initialValueEstoqueState } from "./estoque.model"
import { action } from "typesafe-actions";
import { call, put, take, takeLatest } from "redux-saga/effects";
import { itemController } from "../item/item.controll";
import { Item } from "../item/item.model";
import { ResultDb } from "../../services/db";
import { formatDateIsoValue, getNewId } from "../../services/utils";
import { EstoqueItem, EstoqueItemView, ItemMov, Movimentacao } from "../../data.types";

export interface EstoqueViewProps {
    estoqueState: EstoqueState
    estoqueActions: EstoqueActions
}


class EstoqueController extends Controller<Estoque, EstoqueState, EstoqueActions> {
    constructor() {
        super(initialValueEstoqueState.row.type, initialValueEstoqueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            configEstoque: `@${this.moduloName}/CONFIG_ESTOQUE`,
            readEstoque: `@${this.moduloName}/READ_ESTOQUE`,
            salvarEstoqueAtualizado: `@${this.moduloName}/SALVAR_ESTOQUE_ATUALIZADO`,
            reConfigEstoque: `@${this.moduloName}/RECONFIG_ESTOQUE`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            configEstoque: (estabilizar: boolean) => action(this.actionsType.configEstoque, { estabilizar }),
            readEstoque: () => action(this.actionsType.readEstoque, {}),
            salvarEstoqueAtualizado: () => action(this.actionsType.salvarEstoqueAtualizado, {}),
            reConfigEstoque: () => action(this.actionsType.reConfigEstoque, {}),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.configEstoque, this.configEstoqueEffect.bind(this)),
            takeLatest(this.actionsType.readEstoque, this.readEstoqueEffect.bind(this)),
            takeLatest(this.actionsType.salvarEstoqueAtualizado, this.salvarEstoqueAtualizadoEffect.bind(this)),
            takeLatest(this.actionsType.reConfigEstoque, this.reConfigEstoqueEffect.bind(this)),
        ]
    }

    readEstoque = async (): Promise<ResultDb<Estoque>> => {
        try {
            console.log("chamou read Estoque");
            //definir uma variavel para armazenar o estoque
            let estoque: Estoque = {} as Estoque;
            let estoqueItemView: EstoqueItemView[] = [];
            //buscar o estoque atual, se nao tiver registrado, criar um novo estoque
            let respEstoque = await this.read() as ResultDb<Estoque>;
            if (respEstoque.status === "ok" && respEstoque.rows && respEstoque.rows.length === 0) {
                let respCriarEstoque = await this.configEstoque(false);
                if (respCriarEstoque.status === "ok" && respCriarEstoque.row) {
                    return { status: "ok", row: respCriarEstoque.row, msg: respCriarEstoque.msg! }
                } else {
                    return { status: "error", msg: respCriarEstoque.msg! }
                }
            } else if (respEstoque.status === "ok" && respEstoque.rows && respEstoque.rows.length > 0) {
                estoque = respEstoque.rows[0] as Estoque;
            }
            //popular a variavel de estoque com os itens do estoque atual
            estoque.itens.map(itemEst => {
                estoqueItemView.push({ _id: itemEst.item._id, descricao: itemEst.item.descricao, qt: itemEst.qt })
            })

            //buscar os itens da movimentacao que estao entre a data de atualizacao do estoque e a data atual, para atualizar o estoque somente com as movimentacoes que ocorreram depois da ultima atualizacao
            let dtIniConfig = new Date(estoque.data);
            //adicionar 1 minuto a mais na hora para garantir que nao duplique uma movimentaçao de compra que ja foi calculada ao estoque atual
            dtIniConfig.setTime(dtIniConfig.getTime() + 60000);
            let dtIni = dtIniConfig.toISOString();
            let dtFim = new Date().toISOString();
            let respCalcMov = await this.db.filterView({
                viewName: "func/estoque_calc_by_data",
                opt: {
                    startkey: [dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2), dtIni.substr(11, 2), dtIni.substr(14, 2)],
                    endkey: [dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2), dtFim.substr(11, 2), dtFim.substr(14, 2),{}],
                    group_level: 7
                },
                resultViewFull: true
            }) as ResultDb<any>;
            console.log("respCalcMov", respCalcMov);
            if (respCalcMov.status === "ok") {
                //fazer um loop para atualizar o estoque com as movimentacoes encontradas
                //sendo que o _id do item esta na chave key[3], a qt esta na value
                respCalcMov.rows?.map(mov => {
                    let qt = mov.value as number;
                    let idItem = mov.key[5];
                    let itemEstoque = estoqueItemView.find(item => item._id === idItem);
                    if (itemEstoque) {
                        itemEstoque.qt += qt;
                    } else {
                        //caso nao encontre o item no estoque, adicionar o item com a qt da movimentacao
                        let descricao = mov.key[6];
                        estoqueItemView.push({ _id: idItem, descricao, qt })
                    }
                })
            }
            console.log("estoque atualizado ", estoqueItemView);
            return { status: "ok", rows: estoqueItemView, row: estoque, msg: "Estoque atualizado com sucesso!" }

        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em readEstoque, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err }
        }
    }

    salvarEstoqueAtualizado = async (): Promise<ResultDb<Estoque>> => {
        try {
            console.log("chamou salvarEstoqueAtualizado");
            let estoque: Estoque = {} as Estoque;
            let respEstoque = await this.read() as ResultDb<Estoque>;
            if (respEstoque.status === "ok" && respEstoque.rows && respEstoque.rows.length > 0) {
                estoque = respEstoque.rows[0] as Estoque;
                estoque.data = new Date().toISOString();
                let respEstoqueView = await this.readEstoque() as ResultDb<EstoqueItemView>;
                if (respEstoqueView.status === "ok" && respEstoqueView.rows) {
                    estoque.itens = [];
                    (respEstoqueView.rows as EstoqueItemView[]).map(itemView => {
                        estoque.itens.push({ _id: itemView._id, item: { _id: itemView._id, descricao: itemView.descricao }, qt: itemView.qt })
                    })
                } else {
                    return { status: "error", msg: respEstoqueView.msg! }
                }
                let respSalvar = await this.db.salvar(estoque);
                if (respSalvar.status === "ok" && respSalvar.row) {
                    return { status: "ok", row: respSalvar.row as Estoque, rows: respEstoqueView.rows as Estoque[], msg: "Estoque atualizado com sucesso!" }
                } else {
                    return { status: "error", msg: respSalvar.msg!, row: respSalvar.row as Estoque, rows: respSalvar.rows as Estoque[] }
                }
            } else {
                return { status: "error", msg: "Estoque não encontrado para atualizar!" }
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em salvarEstoqueAtualizado, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err }
        }
    }



    configEstoque = async (estabilizar:boolean): Promise<ResultDb<Estoque>> => {
        console.log("chamou config Estoque");
        try {
            const addItensEstoque = async (estoque: Estoque) => {
                let resp = await itemController.read() as ResultDb<Item>;
                let itens = resp.rows as Item[];
                itens.map((item, i) => {
                    //verifica se ja tem o item no estoque,
                    //se não tiver inclui para manter o doc atualizado
                    if (estoque.itens.findIndex(itemEst => item._id === itemEst.item._id) === -1) {
                        console.log("Nao encontrou no estoque ", [item.codigo, item]);
                        let itemEst: EstoqueItem = { _id: item._id, item: { _id: item._id, descricao: item.descricao }, qt: 0 }
                        console.log("adicionou no estoque ", itemEst);
                        estoque.itens.push(itemEst);
                    }
                })
                return estoque;
            }

            const estabiliza = async (value: Estoque) => {
                //buscar data inicial em config
                let respConfig = await this.db.getDocID("@CONFIG");
                let config = respConfig.row;
                if (config.data_ini_estoque) {
                    let estoque: Estoque = {
                        ...value,
                        data: new Date(config.data_ini_estoque).toISOString(),
                        itens: []
                    }
                    estoque = await addItensEstoque(estoque);
                    let respSalvar: ResultDb<Estoque> = await this.db.salvar(estoque);
                    if (respSalvar.status === "ok" && respSalvar.row) {
                        //atualizar o estoque 
                        let respAtualizar = await this.salvarEstoqueAtualizado();
                        if (respAtualizar.status === "ok" && respAtualizar.row) {
                            return { status: respAtualizar.status, row: respAtualizar.row as Estoque, rows: respAtualizar.rows as Estoque[], msg: "Estoque criado e atualizado com sucesso!" }
                        } else {
                            return { status: respAtualizar.status, msg: respAtualizar.msg!, row: respSalvar.row as Estoque, rows: respSalvar.rows as Estoque[]}
                        }
                    } else {
                        return { status: respSalvar.status, msg: respSalvar.msg!, row: respSalvar.row as Estoque, rows: respSalvar.rows as Estoque[]}
                    }
                } else {
                    return { status: "error" as any, msg: "Data inicial para estoque não configurada! Por favor, configure a data inicial do estoque nas configurações para criar o estoque.", row: value, rows: [] as Estoque[]}
                }

            }


            //verificar se já existe estoque (Só para garantir msm!!)
            let respEstoque = await this.read() as ResultDb<Estoque>;
            if (respEstoque.status === "ok" && respEstoque.rows && respEstoque.rows.length === 0) {
                return estabiliza(this.getInitialValue());
            } else {
                if(estabilizar){
                   return estabiliza(respEstoque.rows![0] as Estoque);
                } else {
                    return respEstoque
                }
                
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em configEstoqueEffect, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err }
        }

    }

    reConfigEstoque = async (): Promise<ResultDb<Estoque>> => {
        try {
            //se tiver estoque, deletar o estoque atual
            let estoque = this.state.row as Estoque;
            if (estoque && estoque._id) {
                let respDelete = await this.db.deleteData(estoque);
                if (respDelete.status === "ok") {
                    let respNew = await this.readEstoque();
                    return respNew;
                } else {
                    return { status: "error", msg: respDelete.msg! }
                }
            } else {
                //caso nao tenha estoque, criar um novo estoque
                let respNew = await this.configEstoque(true);
                return respNew;
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em reConfigEstoque, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err }
        }
    }

    estabilizaEstoque = async (itensMov: ItemMov[]): Promise<ResultDb<Estoque>> => {
        try {

            let estoque = this.state.row as Estoque;
            const estabiliza = () => {
                itensMov.map(itemMov => {
                    let itemEstoque = estoque.itens.find(item => item.item._id === itemMov.item._id);
                    if (itemEstoque) {
                        itemEstoque.qt -= itemMov.qt;
                    }
                });
            }
            if (estoque && estoque._id) {
                //fazer um loop para atualizar o estoque com os itens da movimentacao
                estabiliza();
            } else {//busca o estoque
                let respEstoque = await this.read() as ResultDb<Estoque>;
                if (respEstoque.status === "ok" && respEstoque.rows && respEstoque.rows.length > 0) {
                    estoque = respEstoque.rows[0] as Estoque;
                    estabiliza();
                }
            }
            let respSalvar = await this.db.salvar(estoque);
            if (respSalvar.status === "ok" && respSalvar.row) {
                return { status: "ok", row: respSalvar.row as Estoque, msg: "Estoque estabilizado com sucesso!" }
            } else {
                return { status: "error", msg: respSalvar.msg! }
            }


        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em estabilizaEstoque, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err };
        }
    }

    private * salvarEstoqueAtualizadoEffect(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, msg: "Salvando estoque atualizado...", loadingRows: true, status: "", error: false, showAlert: false },
            this.actionsType.salvarEstoqueAtualizado
        ))
        let respSalvar: ResultDb<Estoque> = yield call(this.salvarEstoqueAtualizado);
        if (respSalvar.status === "ok" && respSalvar.row) {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, estoqueItemView: respSalvar.rows as EstoqueItemView[], row: respSalvar.row, loadingRows: false, msg: respSalvar.msg!, status: respSalvar.status, changeList: new Date().toISOString() },
                this.actionsType.salvarEstoqueAtualizado
            ))
        } else {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: respSalvar.msg!, status: respSalvar.status, error: true, showAlert: true, changeList: new Date().toISOString() },
                this.actionsType.salvarEstoqueAtualizado
            ))
        }
    }

    private * readEstoqueEffect(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, msg: "Atualizando estoque...", loadingRows: true, status: "", error: false, showAlert: false },
            this.actionsType.readEstoque
        ))
        let respAtualizar: ResultDb<Estoque> = yield call(this.readEstoque);
        if (respAtualizar.status === "ok" && respAtualizar.row) {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, estoqueItemView: respAtualizar.rows as EstoqueItemView[], row: respAtualizar.row, loadingRows: false, msg: respAtualizar.msg!, status: respAtualizar.status, changeList: new Date().toISOString() },
                this.actionsType.readEstoque
            ))
        } else {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: respAtualizar.msg!, status: respAtualizar.status, error: true, showAlert: true, changeList: new Date().toISOString() },
                this.actionsType.readEstoque
            ))
        }
    }

    private * configEstoqueEffect(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, msg: "Carregando estoque...", loadingRows: true, status: "", error: false, showAlert: false },
            this.actionsType.configEstoque
        ))
        let respEstoque: ResultDb<Estoque> = yield call(this.configEstoque, actions.payload.estabilizar);
        if (respEstoque.status === "ok" && respEstoque.row) {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, estoqueItemView: respEstoque.rows as EstoqueItemView[], loadingRows: false, row: respEstoque.row as Estoque, msg: respEstoque.msg!, status: respEstoque.status, changeList: new Date().toISOString() },
                this.actionsType.configEstoque
            ))
        } else {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: respEstoque.msg!, status: respEstoque.status, error: true, showAlert: true, changeList: new Date().toISOString() },
                this.actionsType.configEstoque
            ))
        }
    }

    private * reConfigEstoqueEffect(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, msg: "Reconfigurando estoque...", loadingRows: true, status: "", error: false, showAlert: false },
            this.actionsType.reConfigEstoque
        ))
        let respReConfig: ResultDb<Estoque> = yield call(this.reConfigEstoque);
        if (respReConfig.status === "ok") {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: "Reconfiguração do estoque concluída com sucesso!", showAlert: true, status: "ok", changeList: new Date().toISOString() },
                this.actionsType.reConfigEstoque
            ))
        } else {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: respReConfig.msg!, showAlert: true, status: "error", changeList: new Date().toISOString() },
                this.actionsType.reConfigEstoque
            ))
        }
    }

}

export const estoqueController = new EstoqueController()

export const mapStateToEstoqueProps = (state: ApplicationState) => ({
    estoqueState: state.estoqueState,
})

export const mapDispatchToEstoqueProps = (dispatch: Dispatch) => ({
    estoqueActions: bindActionCreators({ ...estoqueController.reducer.actions }, dispatch),
})